// extracted by mini-css-extract-plugin
export var button = "_mq-0";
export var donut = "_mq-1";
export var donutFill = "_mq-3";
export var donutTrack = "_mq-2";